module.exports = __webpack_public_path__ + "img/mount-logo-black.100bb892.jpeg";